import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import {useAudioRecorder} from 'react-audio-voice-recorder'
import Lottie from 'lottie-react'
import * as animationData from '@assets/lotties/mic.json'
import micIcon from '@assets/svgs/mic.svg'
import ic_arrow from '@assets/svgs/ic_arrow.svg'

import './GlobalMic.css'
import {Box, Button, Flex, Image, Text} from '@chakra-ui/react'
import {LOCAL_STORAGE} from '@utils/Const'

interface StatusMicProps {
  maxW?: any
  title: string
}
const MIC_HEIGHT = 70
const StatusMic = ({maxW = '200px', title, ...props}: StatusMicProps) => {
  return (
    <Flex
      maxW={'500px'}
      alignItems={'center'}
      position={'absolute'}
      bottom={MIC_HEIGHT + 5}
      flexDirection={'column'}>
      <Flex
        boxShadow={'0px 2px 8px 0px #00000026'}
        borderRadius={'24px'}
        padding={'14px'}
        paddingRight={'16px'}
        paddingLeft={'16px'}
        bg={'#ffffff'}>
        <Text
          maxW={'500px'}
          fontWeight={600}
          fontSize={'24px'}
          color={'#000000'}>
          {title}
        </Text>
      </Flex>
      <Image w={'11.31px'} h={'5.66px'} src={ic_arrow} />
    </Flex>
  )
}

function GlobalMic({onRecordingComplete = (blob: any) => {}}, ref: any) {
  const [isFirstTimeShow, setIsFirstTimeShow] = useState(false)
  const [isFirstTimeShowEndMic, setIsFirstTimeShowEndMic] = useState(false)
  const {startRecording, stopRecording, recordingBlob, isRecording} =
    useAudioRecorder()

  useImperativeHandle(
    ref,
    () => ({
      handlePressMic,
    }),
    [],
  )

  useEffect(() => {
    if (!recordingBlob) return
    onRecordingComplete(recordingBlob)
    // recordingBlob will be present at this point after 'stopRecording' has been called
  }, [recordingBlob])

  useEffect(() => {
    try {
      const isShow = sessionStorage.getItem(
        LOCAL_STORAGE.IS_SHOW_START_MIC_TOOL_TIP,
      )
      const isShowEndMic = sessionStorage.getItem(
        LOCAL_STORAGE.IS_SHOW_END_MIC_TOOL_TIP,
      )
      if (isShow !== 'true') {
        setIsFirstTimeShow(true)
      }
      if (isShowEndMic !== 'true') {
        setIsFirstTimeShowEndMic(true)
      }
    } catch (e) {}
  }, [])

  const handlePressMic = () => {
    sessionStorage.setItem(LOCAL_STORAGE.IS_SHOW_START_MIC_TOOL_TIP, 'true')
    sessionStorage.setItem(LOCAL_STORAGE.IS_SHOW_END_MIC_TOOL_TIP, 'true')
    setIsFirstTimeShow(false)
    if (isRecording) {
      stopRecording()
    } else {
      startRecording()
    }
  }

  const renderStatus = () => {
    if (isRecording) {
      if (!isFirstTimeShowEndMic) {
        return <div />
      }
      return <StatusMic title={'Bấm khi hoàn tất'} />
    } else if (isFirstTimeShow) {
      return <StatusMic title={'Bấm để trả lời'} />
    }
    return <div />
  }

  return (
    <Flex
      position={'relative'}
      style={{width: '100%'}}
      flexDirection={'column'}
      alignItems={'center'}>
      {renderStatus()}
      <Button
        w={140}
        h={MIC_HEIGHT}
        borderRadius={50}
        onClick={handlePressMic}
        bgGradient={
          isRecording
            ? 'linear(to-r, #FFA800, #FFC34F)'
            : 'linear(to-r, #07D2FF, #00A3FF)'
        }
        style={{backgroundColor: isRecording ? 'orangered' : '#00A3FF'}}>
        {isRecording ? (
          <Lottie animationData={animationData} />
        ) : (
          <img src={micIcon} />
        )}
      </Button>
    </Flex>
  )
}

export default forwardRef(GlobalMic)
